import { Grid, IconButton } from "@mui/material";
import {
  Comment,
  Delete as DeleteIcon,
  List as ListIcon,
} from "@mui/icons-material";
import type { ICellRendererParams } from "ag-grid-community";
type Props = {
  params: ICellRendererParams;
  justifyData: (params: ICellRendererParams) => void;
  deleteData: (params: ICellRendererParams) => void;
  showContextMenu: () => void;
};
export const GridButtons = ({
  params,
  justifyData,
  deleteData,
  showContextMenu,
}: Props) => {
  return (
    <Grid
      container
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="ag-grid-buttons"
    >
      <Grid
        item
        xs={12}
        md={12}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <IconButton
          aria-label="justify-icon"
          title="Justify"
          style={{ cursor: "pointer" }}
          onClick={() => justifyData(params.data)}
        >
          <Comment
            fontSize="inherit"
            color="primary"
            style={{ cursor: "pointer" }}
          />
        </IconButton>
        {params.data.IsDelayManual && (
          <IconButton
            aria-label="delete-icon"
            style={{ cursor: "pointer" }}
            title="Delete"
            onClick={() => {
              deleteData(params.data);
            }}
          >
            <DeleteIcon
              fontSize="inherit"
              color="secondary"
              style={{ cursor: "pointer" }}
            />
          </IconButton>
        )}
        <IconButton
          aria-label="Options"
          title="Options"
          style={{ cursor: "pointer" }}
          onClick={showContextMenu}
        >
          <ListIcon
            fontSize="inherit"
            color="primary"
            style={{ cursor: "pointer" }}
          />
        </IconButton>
      </Grid>
    </Grid>
  );
};
